<template>
  <span v-if="chain.length > 0" class="ml-2 inline-flex items-center rounded-full bg-gray-100 px-2.5 py-0.5 text-xs font-medium text-gray-800">
    For CNAME&nbsp;
    <span v-for="(cname, index) in chain" :key="index">
      <span v-if="index !== 0"> &larr; </span>
      <dns-records-link :domain="cname" class="text-blue-600 hover:text-blue-800 hover:underline" />
    </span>
  </span>
</template>

<script setup lang="ts">
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';

defineProps({
  chain: {
    type: Array as () => Array<string>,
    required: true,
  },
});
</script>
